import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import { useMeasure } from 'react-use';
import LineNav from '@/components/navigation/LineNav';
import ButtonListNav from '@/components/navigation/ButtonListNav';
import Button from '@/components/Button';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var PlayIcon = function PlayIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "#828699",
      fillRule: "evenodd",
      d: "M0 4.007C0 .71 3.762-1.17 6.399.806l7.997 5.993c2.135 1.6 2.135 4.802 0 6.402L6.4 19.194C3.762 21.17 0 19.289 0 15.994V4.006Zm5.2-1.6C3.88 1.417 2 2.358 2 4.006v11.986c0 1.648 1.88 2.589 3.2 1.6l7.997-5.993a2 2 0 0 0 0-3.2L5.199 2.405Z",
      clipRule: "evenodd"
    })
  }));
};

PlayIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "20",
  fill: "none"
};

var CircleQuestionIcon = function CircleQuestionIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_533_1081)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z",
        fill: "#828699"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.13323 7.50073C8.85668 7.97879 8.24496 8.14215 7.7669 7.86561C7.28884 7.58906 7.12547 6.97733 7.40202 6.49927C7.91922 5.60518 8.88838 5 10.0001 5C11.6569 5 13.0001 6.34315 13.0001 8C13 9.09773 12.3267 9.99398 11.5001 10.5C10.8361 10.9065 11.2501 12 9.99744 12C9.44515 12 8.99744 11.5523 8.99744 11C8.99744 10.9649 8.99925 10.9302 9.00278 10.896C9.03051 10.3672 9.26633 9.93684 9.5231 9.62394C9.79427 9.29348 10.1508 9.02371 10.4234 8.86165C11.9401 7.96 10.0902 6.1154 9.13323 7.50073ZM9.99744 13C9.44515 13 8.99744 13.4477 8.99744 14C8.99744 14.5523 9.44515 15 9.99744 15C10.5497 15 10.9974 14.5523 10.9974 14C10.9974 13.4477 10.5497 13 9.99744 13Z",
        fill: "#828699"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_533_1081",
        children: /*#__PURE__*/_jsx("rect", {
          width: "20",
          height: "20",
          fill: "white"
        })
      })
    })]
  }));
};

CircleQuestionIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const EditorStepNav = _ref => {
  let {
    links = [],
    active = '',
    notice = '',
    className,
    onOpen,
    onAltOpen
  } = _ref;
  // Responsive queries
  const [containerEl, {
    width
  }] = useMeasure();
  const isSmallLayout = width < 680;
  const isMediumLayout = width > 900;
  return /*#__PURE__*/_jsxs("div", {
    // @ts-ignore
    ref: containerEl,
    className: clsx(styles.container, className || ''),
    children: [isSmallLayout ? /*#__PURE__*/_jsx(LineNav, {
      className: styles.links,
      links: links,
      notice: notice,
      active: active || getFirstHref(links),
      onOpen: onOpen
    }) : /*#__PURE__*/_jsx(ButtonListNav, {
      className: styles.links,
      links: links,
      notice: notice,
      active: active,
      onOpen: onOpen
    }), /*#__PURE__*/_jsx(SideButton, {
      isMediumLayout: isMediumLayout,
      onClick: onAltOpen
    })]
  });
};

export default EditorStepNav;

function getFirstHref(links) {
  return (links[0] || {
    href: ''
  }).href || '';
}

const SideButton = _ref2 => {
  let {
    isMediumLayout,
    onClick
  } = _ref2;

  if (!onClick) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  return !isMediumLayout ? /*#__PURE__*/_jsx(Button, {
    size: "small",
    variant: "text",
    className: styles.sideButton,
    leftIcon: /*#__PURE__*/_jsx(CircleQuestionIcon, {
      className: styles.sideButton__icon
    }),
    onClick: onClick
  }) : /*#__PURE__*/_jsx(Button, {
    size: "small",
    variant: "text",
    className: styles.sideButton,
    leftIcon: /*#__PURE__*/_jsx(PlayIcon, {
      className: styles.sideButton__icon
    }),
    onClick: onClick,
    children: "Tutorial"
  });
};